import React from 'react';
import { actions as mailActions } from '@web-common/state/reducer/mailReducer';
import { ReactComponent as EdmInfoBlueFill } from '@/images/icons/edm/info-blue-fill.svg';
import { useAppDispatch, useAppSelector } from '@web-common/state/createStore';
import { getIn18Text } from 'api';
import styles from './attUploading.module.scss';
const AttUploading = React.forwardRef((props) => {
    const currentMailId = useAppSelector(state => state.mailReducer.currentMail.cid);
    const dispatch = useAppDispatch();
    const cancelSend = () => {
        currentMailId && dispatch(mailActions.doRemWaittingMailId(currentMailId));
    };
    return (React.createElement("div", { className: styles.attUploading },
        React.createElement(EdmInfoBlueFill, null),
        React.createElement("span", { className: styles.uploadingText }, getIn18Text('ZHENGZAISHANGCHUANFUJ，SCWCHJZDFS')),
        React.createElement("span", { className: styles.cancelSend, onClick: cancelSend }, getIn18Text('QUXIAOFASONG'))));
});
export default AttUploading;
